export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function isAnEmail(email: string): boolean {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
}